// extracted by mini-css-extract-plugin
export default {"panel":"Panel_panel__ICDea","info":"Panel_info__j60xy","note":"Panel_note__sjN5f","close":"Panel_close__sgDej","btns":"Panel_btns__qq0Bc","button":"Panel_button__697Br"};